export const navLinks = [
  { label: 'Home', href: '/' },
  { label: 'Work', href: '/work' },
  { label: 'Contact', href: '/contact' },
];

export const reelFrames = [
  {
    alt: 'Wide view of a brand launch stage washed in soft violet light with a crowd silhouetted below',
    src: 'https://public.readdy.ai/ai/img_res/sandbox/9375ca16a27728ad5f5dab836bff4134/c823f1e9-95a6-4af6-9758-a408c949de9b_ff-reel-01.webp',
  },
  {
    alt: 'Immersive light installation with visitors walking through glowing suspended panels',
    src: 'https://public.readdy.ai/ai/img_res/sandbox/9375ca16a27728ad5f5dab836bff4134/c823f1e9-95a6-4af6-9758-a408c949de9b_ff-reel-02.webp',
  },
  {
    alt: 'Energetic audience with raised hands in front of a live performance stage',
    src: 'https://public.readdy.ai/ai/img_res/sandbox/9375ca16a27728ad5f5dab836bff4134/c823f1e9-95a6-4af6-9758-a408c949de9b_ff-reel-03.webp',
  },
];

export const featuredCase = {
  title: 'After Hours',
  headline: 'After Hours, New York. Nine rooms, one story, a city that stayed until sunrise.',
  category: 'Brand Experience',
  location: 'New York',
  summary: 'An overnight brand world built inside a disused printworks, where every room revealed a new chapter of the product story.',
  facts: [
    { label: 'Format', value: 'Overnight brand experience' },
    { label: 'Spaces', value: 'Nine rooms, one narrative' },
    { label: 'Our role', value: 'Concept, design, production' },
  ],
  alt: 'Nighttime brand experience in a warehouse with guests under a glowing ceiling installation',
  src: 'https://public.readdy.ai/ai/img_res/sandbox/9375ca16a27728ad5f5dab836bff4134/c823f1e9-95a6-4af6-9758-a408c949de9b_ff-feat-01.webp',
};

export const projects = [
  {
    slug: 'new-perspectives',
    title: 'New Perspectives',
    category: 'Creative Summit',
    location: 'London',
    line: 'A two-day summit staged in the round, so every voice was heard from every seat.',
    alt: 'Speaker on a minimal circular stage in front of a seated audience at a creative summit',
    src: 'https://public.readdy.ai/ai/img_res/sandbox/9375ca16a27728ad5f5dab836bff4134/c823f1e9-95a6-4af6-9758-a408c949de9b_ff-work-02b.webp',
  },
  {
    slug: 'the-art-of-gathering',
    title: 'The Art of Gathering',
    category: 'Private Experience',
    location: 'Copenhagen',
    line: 'Forty guests, one long table and a menu written around the stories of the people seated at it.',
    alt: 'Long candlelit table in a Scandinavian space set for an intimate private gathering',
    src: 'https://public.readdy.ai/ai/img_res/sandbox/9375ca16a27728ad5f5dab836bff4134/c823f1e9-95a6-4af6-9758-a408c949de9b_ff-work-03b.webp',
  },
  {
    slug: 'into-the-light',
    title: 'Into the Light',
    category: 'Product Launch',
    location: 'Paris',
    line: 'A single beam, a held breath, and a reveal timed to the second.',
    alt: 'Product reveal with a beam of white light over a podium and an audience watching in Paris',
    src: 'https://public.readdy.ai/ai/img_res/sandbox/9375ca16a27728ad5f5dab836bff4134/c823f1e9-95a6-4af6-9758-a408c949de9b_ff-work-04b.webp',
  },
];

export const services = [
  {
    no: '01',
    name: 'Brand Activations',
    focus: 'Launches, pop-ups, touring brand worlds',
    copy: 'Spaces and moments that let people step inside a brand. We turn a message into something you can walk through, touch and share.',
    tone: 'violet-pale',
    alt: 'Crowd exploring a sculptural brand pop-up installation',
    src: 'https://public.readdy.ai/ai/img_res/sandbox/9375ca16a27728ad5f5dab836bff4134/c823f1e9-95a6-4af6-9758-a408c949de9b_ff-svc-01b.webp',
  },
  {
    no: '02',
    name: 'Corporate Experiences',
    focus: 'Summits, retreats, kick-offs, celebrations',
    copy: 'Gatherings people actually want to attend. Company moments designed with the care of a cultural event, so the message lands and the energy lasts.',
    tone: 'mist',
    alt: 'Beautifully lit corporate gathering in a modern hall with guests talking',
    src: 'https://public.readdy.ai/ai/img_res/sandbox/9375ca16a27728ad5f5dab836bff4134/c823f1e9-95a6-4af6-9758-a408c949de9b_ff-svc-02b.webp',
  },
  {
    no: '03',
    name: 'Creative Production',
    focus: 'Sets, staging, light, sound, show calling',
    copy: 'The craft behind the moment. One team managing design, build and technical delivery, sweating the details so the experience feels effortless.',
    tone: 'violet-muted',
    alt: 'Production crew rigging lights above a stage during setup',
    src: 'https://public.readdy.ai/ai/img_res/sandbox/9375ca16a27728ad5f5dab836bff4134/c823f1e9-95a6-4af6-9758-a408c949de9b_ff-svc-03b.webp',
  },
];

export const phases = [
  { word: 'Imagine', copy: 'Listen hard, find the insight, shape one distinctive idea.' },
  { word: 'Design', copy: 'Turn it into spaces, flows, light and moments people can feel.' },
  { word: 'Deliver', copy: 'Produce every detail and run the day with calm precision.' },
];

export const approachImage = {
  alt: 'Behind the scenes: a producer reviewing a stage under construction before doors open',
  src: 'https://public.readdy.ai/ai/img_res/sandbox/9375ca16a27728ad5f5dab836bff4134/c823f1e9-95a6-4af6-9758-a408c949de9b_ff-approach-02.webp',
};

export const stories = [
  {
    label: 'Field note',
    title: 'Designing the first ten seconds through the door.',
    excerpt: 'Arrival sets the emotional tone for everything after it. We sketch the entrance before we sketch the stage.',
    marker: 'primary',
    alt: 'Guests stepping through a softly lit violet entrance tunnel at an event',
    src: 'https://public.readdy.ai/ai/img_res/sandbox/9375ca16a27728ad5f5dab836bff4134/c823f1e9-95a6-4af6-9758-a408c949de9b_ff-story-01.webp',
  },
  {
    label: 'Studio',
    title: 'Building sets that travel, fold and live a second life.',
    excerpt: 'Modular scenery from our workshop is designed to be rebuilt, reused and repurposed long after doors close.',
    marker: 'accent',
    alt: 'Set builders assembling modular arch scenery in a bright workshop',
    src: 'https://public.readdy.ai/ai/img_res/sandbox/9375ca16a27728ad5f5dab836bff4134/c823f1e9-95a6-4af6-9758-a408c949de9b_ff-story-02.webp',
  },
  {
    label: 'Process',
    title: 'Run of show: keeping a thousand moving parts effortless.',
    excerpt: 'One document, one calm voice on the headset. How our producers call a show to the second.',
    marker: 'ink',
    alt: 'Producer with headset calling cues at a backstage control desk',
    src: 'https://public.readdy.ai/ai/img_res/sandbox/9375ca16a27728ad5f5dab836bff4134/c823f1e9-95a6-4af6-9758-a408c949de9b_ff-story-03.webp',
  },
];

export const finaleImage = {
  alt: 'Dramatic wide shot of a crowd facing a glowing stage at the climax of an event',
  src: 'https://public.readdy.ai/ai/img_res/sandbox/9375ca16a27728ad5f5dab836bff4134/c823f1e9-95a6-4af6-9758-a408c949de9b_ff-finale-02.webp',
};

export const eventTypes = [
  'New project',
  'General enquiry',
  'Brand Activation',
  'Corporate Experience',
  'Creative Production',
];